/* eslint-disable wrap-iife */
/* eslint-disable import/prefer-default-export */
/* eslint-env browser */
const copyToClipboard = (str: string): void => {
  // eslint-disable-next-line no-console
  navigator.clipboard.writeText(str).then(() => console.log(`${str} written to clipboard`));
};

const isElementWithClassNameInEventPath = (event: MouseEvent, className: string): boolean => {
  let found = false;
  const path = event.composedPath();
  path.forEach((p: EventTarget): void => {
    if ((p as HTMLElement).classList) {
      if ((p as HTMLElement).classList.contains(className)) {
        found = true;
      }
    }
  });
  return found;
};

const setMetaThemeColor = (): void => {
  const body = document.querySelector('body');
  if (body) {
    const bgColor = window.getComputedStyle(body).getPropertyValue('--color-background');
    const existingMeta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement;
    if (existingMeta) {
      existingMeta.content = bgColor;
    } else {
      const meta = document.createElement('meta');
      meta.name = 'theme-color';
      meta.content = bgColor;
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }
};

const getBaseFontSize = (): number => parseInt(window.getComputedStyle(document.documentElement).fontSize.replace('px', ''), 10);

export {
  copyToClipboard,
  isElementWithClassNameInEventPath,
  getBaseFontSize,
  setMetaThemeColor,
};
